import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import cx from 'classnames';
import s from './MobileMovieInfo.module.scss';
import { gtmUtils } from '../../services/GTMUtils';
import { MovieSchema } from '../Schemas';
import { FROM_AD_BANNER, FROM_TRENDING } from '../../constants/moviesConst';
import { getSentimentCount } from '../../services/sentimentServices';
import { checkH5ScreenName, formatMovieDuration } from '../../services/coreUtil';
import dayjs from 'dayjs';
import { getImagesFromCDN } from '../../services/coreUtil';
import { getCityUrl } from '../../services/urlCreator';
import { goBack, isH5Container, openYTvideo } from '../../services/h5Service';
import dynamic from 'next/dynamic';
import { closeWindow } from '../../h5Utils/h5CoreUtil';
const MovieVideoPlayer = dynamic(() => import('../MovieVideoPlayer/MovieVideoPlayer'), {
	ssr: false,
});

const gaPayload = {
	event_category: 'Movie Tickets - Showtime',
	screenName: `${checkH5ScreenName('Movie Tickets - Showtime')}`,
};

class MobileMovieInfo extends React.Component {
	state = {
		showVideoPlayer: false,
		searchExpanded: false,
		searchInputValue: null,
	};

	searchInputRef = React.createRef<HTMLInputElement>();
	resetText = React.createRef<HTMLInputElement>();
	nameConWrap = React.createRef();
	nameWrap = React.createRef();

	getBannerDetails = () => {
		const { movieDetails } = this.props;
		const langFormatGroup = movieDetails?.languageFormatGroups?.find(
			(lfg) => lfg.fmtGrpId === this.props.frmtid,
		);
		let bannerDetails = {
			image: movieDetails?.bannerImageApp,
			video: movieDetails?.bannerVideo,
		};
		if (this.props.frmtid && langFormatGroup) {
			bannerDetails = {
				image: langFormatGroup.appCvrPath,
				video: langFormatGroup.trailer,
			};
		}
		return bannerDetails;
	};

	openVideoPlayer = async () => {
		const { cityName } = this.props;
		const { movieDetails = {}, languageSelected, contentId } = this.props;
		const { name } = movieDetails;
		const videoUrl = this.getBannerDetails().video || '';

		gtmUtils.gtmMoviePageEvents({
			...gaPayload,
			event_label5: cityName,
			event_action: 'Movie Trailer Video Play Click',
			event_label6: movieDetails?.name,
			event_label7: String(contentId),
			event_label11: languageSelected?.lang || null,
		});

		if (isH5Container()) {
			return openYTvideo({
				videoUrl,
				name,
			});
		}
		this.setState({ showVideoPlayer: true });
	};

	closeVideoPlayer = async () => {
		this.setState({ showVideoPlayer: false });
	};

	toggleSearch = (eventObj) => {
		const { searchExpanded } = this.state;
		if (!searchExpanded) {
			this.searchInputRef?.current?.focus();
			gtmUtils.gtmMoviePageEvents(eventObj);
		}
		this.setState((prevState) => {
			return { searchExpanded: !prevState.searchExpanded };
		});
	};

	closeSearch = () => {
		this.toggleSearch();
		this.props.resetSearch();
	};

	componentDidMount() {
		this.storedDataInSS = window.sessionStorage.getItem(FROM_AD_BANNER);
		this.fromTrending = window.sessionStorage.getItem(FROM_TRENDING);

		let conOffsetWidth = this.nameConWrap.current?.offsetWidth;
		let nameOffsetWidth = this.nameWrap.current?.offsetWidth;
		let requestAnimationFrame =
			window.requestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.msRequestAnimationFrame;
		const nameWrapper = this.nameWrap.current;
		let currentPos = 0;
		const animLoop = () => {
			currentPos += 0.3;
			nameWrapper.style.transform = `translateX(-${currentPos}px)`;

			if (currentPos >= nameOffsetWidth - (conOffsetWidth - 32)) {
				nameWrapper.style.transition = 'opacity 0.4s';
				nameWrapper.style.opacity = '0';
			}

			if (currentPos >= nameOffsetWidth - (conOffsetWidth - 45)) {
				//window.cancelAnimationFrame(reqId);
				currentPos = 0;
				nameWrapper.style.transform = `translateX(-${currentPos}px)`;
			}

			this.animId = requestAnimationFrame(animLoop);

			if (currentPos == 0) {
				cancelAnimationFrame(this.animId);
				nameWrapper.style.transition = 'opacity 1.5s';
				nameWrapper.style.opacity = '1';
				setTimeout(() => {
					animLoop();
				}, 2500);
			}
		};

		if (nameOffsetWidth >= conOffsetWidth) {
			setTimeout(() => {
				animLoop();
			}, 2500);
		}
	}

	componentWillUnmount() {
		cancelAnimationFrame(this.animId);
	}

	render() {
		const {
			movieDetails = {},
			path,
			onSearch,
			searchInputValue,
			showSearch = false,
			cityName,
			contentId,
		} = this.props;
		const url = this.storedDataInSS ? '' : getCityUrl(cityName);
		const { content, isReleased, censor, genre, name, duration, metricInfo, ratings } =
			movieDetails;
		const bannerDetails = this.getBannerDetails();
		const sentimentCountData = getSentimentCount(metricInfo);
		const movieName = get(movieDetails, 'name', '');
		const likePercent = metricInfo?.sentiment?.percentage;
		const imdbValue = ratings?.IMDB?.value;
		const langFormatGroup = movieDetails?.languageFormatGroups?.find(
			(lfg) => lfg.fmtGrpId === this.props.frmtid,
		);
		const eventObject = {
			...gaPayload,
			event_action: 'search_focus_in',
			event_label5: cityName,
			event_label6: movieName,
			event_label7: contentId,
			event_label11: langFormatGroup?.lang || null,
		};
		return (
			!isEmpty(movieDetails) && (
				<div className={s.movieInfo}>
					<MovieSchema path={path} sentimentCountData={sentimentCountData} movie={movieDetails} />
					<a
						onClick={(e) => {
							e.preventDefault();
							if (this.fromTrending) {
								return closeWindow();
							}
							goBack(url);
						}}
					>
						<i className={cx('backWhite', s.backArrowIcon)} />
					</a>
					{showSearch && (
						<div className={s.box}>
							<div
								className={`${s.searchContainer} ${this.state.searchExpanded ? s.expanded : ''}`}
							>
								<span>
									<i
										className={cx(
											'searchIconMDP',
											s.searchPlaceholder,
											this.state.searchExpanded ? s.expanded : '',
										)}
									/>
								</span>
								<input
									className={`${s.search} ${this.state.searchExpanded ? s.expanded : ''}`}
									type="search"
									placeholder="Search Cinema"
									onChange={onSearch}
									value={searchInputValue}
									ref={this.searchInputRef}
								/>
								{/* <span className={s.resetSearch} ref={this.resetText} onClick={this.resetSearch}></span> */}
								<i
									onClick={this.closeSearch}
									className={cx(
										'closeIconMDP',
										s.closeIconMDP,
										this.state.searchExpanded ? s.expanded : '',
									)}
								>
									<span className="path1" />
									<span className="path2" />
								</i>
							</div>
							<i
								className={cx('searchWhite', s.searchWhite)}
								onClick={(event) => this.toggleSearch(eventObject)}
							/>
						</div>
					)}
					{!!this.state.showVideoPlayer && (
						<MovieVideoPlayer
							video={{ videoUrl: bannerDetails?.video }}
							onCloseHandler={this.closeVideoPlayer}
							noPadding={true}
							animation={true}
							showCloseButton={true}
							playerWidth={'100%'}
							playerHeight={'100%'}
						/>
					)}
					{!!bannerDetails?.video?.includes('youtu') && (
						<i onClick={this.openVideoPlayer} className={cx('videoPlay', s.playIcon)} />
					)}
					{/* <LazyLoad height="100%" width="100%"> */}
					{!!bannerDetails.image && (
						<img
							src={getImagesFromCDN(bannerDetails.image)}
							alt={movieName}
							className={s.movieCoverImage}
						/>
					)}

					{/* </LazyLoad> */}
					<div className={s.gradient} />
					<div className={s.dataBox}>
						{isReleased && !!get(movieDetails, 'ratings') && (
							//<ImdbRating movieName={movieName} ratings={get(movieDetails, 'ratings.IMDB')} />
							<div className={s.movieRatings}>
								{likePercent && (
									<div className={s.heartCon}>
										<i className={cx('redHeartSolid', s.redHeartSolid)}></i>
										{likePercent}%
									</div>
								)}
							</div>
						)}
						<div ref={this.nameConWrap} className={s.nameWrap}>
							<h1 ref={this.nameWrap} /*data-animate={'false'}*/>{name}</h1>
						</div>
						{/* <Link method="push" to={movieDetails.detailUrl}>
              {isEqual(selectedTab, MOVIE_DETAIL) ? <h1>{name}</h1> : <h2>{name}</h2>}
            </Link> */}
						{isReleased && (
							<div className={s.tags}>
								<ul>
									{!!censor && <li>{censor}</li>}
									{!!duration && <li>{formatMovieDuration(duration)}</li>}
									{!!get(genre, 'length') && (
										<li key={genre}>
											<a key={genre}>{genre.join(', ')}</a>
										</li>
									)}
								</ul>
								{!!content && (
									<ul>
										<li>{content}</li>
									</ul>
								)}
							</div>
						)}
						{!isReleased && movieDetails?.releaseDate && (
							<div className={s.releaseDate}>
								Releasing {dayjs(movieDetails?.releaseDate).format('DD MMM YYYY')}
							</div>
						)}
					</div>
				</div>
			)
		);
	}
}

export default MobileMovieInfo;
